import { useParams } from "react-router-dom";

export const useInvoiceSpecificationId = () => {
  const { invoiceSpecificationId } = useParams();

  if (!invoiceSpecificationId) {
    throw new Error("Invoice specification ID is required");
  }

  return invoiceSpecificationId as string;
};
